import { doc, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";

export async function createOrderWithSequence(orderUid, orderPayload) {
  const counterRef = doc(db, "system", "ordersCounter");
  const orderRef = doc(db, "orders", orderUid);

  return await runTransaction(db, async (transaction) => {
    const counterSnap = await transaction.get(counterRef);

    let lastOrderNumber = 0;

    if (counterSnap.exists()) {
      lastOrderNumber = Number(counterSnap.data()?.lastOrderNumber || 0);
    }

    const nextOrderNumber = lastOrderNumber + 1;
    const orderCode = `ORD-${String(nextOrderNumber).padStart(6, "0")}`;

    transaction.set(
      counterRef,
      {
        lastOrderNumber: nextOrderNumber,
        updatedAt: serverTimestamp(),
      },
      { merge: true },
    );

    transaction.set(orderRef, {
      ...orderPayload,
      uid: orderUid,
      orderNumber: nextOrderNumber,
      orderCode,
      updatedAt: serverTimestamp(),
    });

    return {
      orderNumber: nextOrderNumber,
      orderCode,
    };
  });
}
